import Typography from '@mui/material/Typography';
import { ListItem, Divider, List, Box } from '@mui/material';
import { Company } from '@lendica/utils';

export default function AccountCard({ companyProfile }: { companyProfile: Company | undefined }) {
    return (
        <Box sx={{ borderRadius: 2, background: '#f8f8fb' }}>
            <List>
                <ListItem
                    disableGutters
                    sx={{
                        paddingX: 2,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant="caption" fontSize={14} color="text.primary">
                        Name
                    </Typography>
                    <Typography variant="caption" fontSize={14} color="text.primary">
                        {(companyProfile?.first_name || '') +
                            ' ' +
                            (companyProfile?.last_name || '')}
                    </Typography>
                </ListItem>
                <Divider />
                <ListItem
                    disableGutters
                    sx={{
                        paddingX: 2,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant="caption" fontSize={14} color="text.primary">
                        Company Name
                    </Typography>
                    <Typography variant="caption" fontSize={14} color="text.primary">
                        {companyProfile?.company_name || ''}
                    </Typography>
                </ListItem>
                <Divider />
                <ListItem
                    disableGutters
                    sx={{
                        paddingX: 2,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant="caption" fontSize={14} color="text.primary">
                        Phone Number
                    </Typography>
                    <Typography variant="caption" fontSize={14} color="text.primary">
                        {companyProfile?.phone_number || ''}
                    </Typography>
                </ListItem>
                <Divider />
                <ListItem
                    disableGutters
                    sx={{
                        paddingX: 2,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant="caption" fontSize={14} color="text.primary">
                        Email
                    </Typography>
                    <Typography variant="caption" fontSize={14} color="text.primary">
                        {companyProfile?.email || ''}
                    </Typography>
                </ListItem>
                <Divider />
                <ListItem
                    disableGutters
                    sx={{
                        paddingX: 2,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant="caption" fontSize={14} color="text.primary">
                        Company Address
                    </Typography>
                    <Typography variant="caption" fontSize={14} color="text.primary">
                        {companyProfile?.company_address || ''}
                    </Typography>
                </ListItem>
            </List>
        </Box>
    );
}
